import { DELIVERY_STATUS } from '~constants/delivery';

export const DELIVERY_STATUS_BADGE_CONFIG = {
  [DELIVERY_STATUS.REJECTED]: { color: 'red' },
  [DELIVERY_STATUS.EXPIRED]: { color: 'red' },
  [DELIVERY_STATUS.PREORDER]: { color: 'gray' },
  [DELIVERY_STATUS.CONFIRMED]: { color: 'green' },
  [DELIVERY_STATUS.CANCELLED]: { color: 'red' },
  [DELIVERY_STATUS.IN_PROGRESS]: { color: 'gray' },
  [DELIVERY_STATUS.NEAR_PICKUP]: { color: 'blue' },
  [DELIVERY_STATUS.PICKED_UP]: { color: 'blue' },
  [DELIVERY_STATUS.NEAR_DROPOFF]: { color: 'blue' },
  [DELIVERY_STATUS.COMPLETED]: { color: 'green' },
  [DELIVERY_STATUS.NO_DELIVERY]: { color: 'red' }
};
